module.exports = __webpack_public_path__ + "media/images/garde d'enfants-772c07f7e939ebc60229a8cabd6a9d3e.svg";